import PropTypes from 'prop-types';

import { ThemeContextProvider } from '../../contexts/ThemeContext.js';
import MainHeader from './MainHeader.js';
import { Box, Container } from '@mui/material';

function LayoutV2({ activeLinkText, showLoginOption = true, children }) {
  return (
    <ThemeContextProvider>
      <Container maxWidth="md"
        style={{
          paddingLeft: '0px',
          paddingRight: '0px',
        }}>
        <MainHeader showLoginOption={showLoginOption} activeLink={activeLinkText} />
        <Box>
          {children}
        </Box>
      </Container>
    </ThemeContextProvider>
  );
}

LayoutV2.propTypes = {
  activeLinkText: PropTypes.string.isRequired,
  showLoginOption: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

LayoutV2.defaultProps = {
  activeLinkText: '',
};

export default LayoutV2;
